"use client";

import React from "react";
const logos = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1608524/img/logo_metrc.png",
  alt: "Metrc"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1608524/img/logo_docusign.png",
  alt: "DocuSign"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1608524/img/logo_weedmaps.png",
  alt: "Weedmaps"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1608524/img/logo_leafly.png",
  alt: "Leafly"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1608524/img/logo_dutchie.png",
  alt: "Dutchie"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1608524/img/logo_onfleet.png",
  alt: "Onfleet"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1608524/img/logo_salesforce.png",
  alt: "Salesforce"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1608524/img/logo_springbig.png",
  alt: "Springbig"
}];
export default function TrustedByTheSecure() {
  return <section data-section-id="147294" id="integrated-ecosystem-partners" className="bg-[#F8FAFC] text-[#0F172A] py-[80px] overflow-hidden relative border-y border-[#134B75]/10">
      <style>{`
        @keyframes marquee-scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          animation: marquee-scroll 40s linear infinite;
        }
      `}</style>

      <div className="container mx-auto px-4 mb-12 text-center relative z-10">
        <p className="text-xs md:text-sm font-mono tracking-[0.2em] text-[#0F172A]/60 uppercase">
          TRUSTED BY & INTEGRATED WITH
        </p>
      </div>

      {}
      <div className="relative w-full flex overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_15%,black_85%,transparent)]">
        
        {}
        <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
          {}
          {[...logos, ...logos].map((logo, i) => <div key={i} data-index={i} className="flex items-center justify-center w-[200px] md:w-[280px] px-8 group">
              <img src={logo.src} alt={logo.alt} className="h-8 md:h-10 w-auto object-contain grayscale brightness-0 opacity-40 transition-all duration-500 ease-out group-hover:grayscale-0 group-hover:brightness-100 group-hover:opacity-100 group-hover:drop-shadow-[0_0_15px_rgba(26,90,142,0.2)] cursor-pointer" />
            </div>)}
        </div>
        
      </div>
      
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80%] h-[50%] bg-[#1A5A8E]/5 blur-[120px] pointer-events-none rounded-full" />
    </section>;
}